import React from 'react'
import styled from 'styled-components'
import { SerializedError } from '@reduxjs/toolkit'
import { SummaryMetricsCompactWidgetsType } from 'components/widget/SummaryMetricsCompactWidgets/types'
import { SummaryMetricsCompact } from 'components/widget/SummaryMetricsCompactWidgets/share/SummaryMetricsCompact'
import { useInsightContentData } from 'hooks/useInsightModalState'
import { Status } from 'features/types'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { DashboardWidgetData } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { FetchErrorResponse } from 'api'
import { useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'
import { setAutoId, AutomationId } from 'utils/automationUtil'
import RunSearchEffect from './RunSearchEffect'
import InsightContentLoadingGuard from './InsightContentLoadingGuard'
import Tile from './Tile'

const Container = styled.div.attrs(() => setAutoId(AutomationId.fluctuationSummary.metrics))<{
  $theme: SystemTheme
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 96px;
  box-sizing: border-box;
  padding: 0 16px;
  border: 1px solid ${({ $theme }) => $theme.common.divider[100]};
`

const StyledSummaryMetricsCompact = styled(SummaryMetricsCompact)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

interface FluctuationSummaryMetricsProps {
  widgetSetting: SummaryMetricsCompactWidgetsType
  isAudienceQuery?: boolean
}

const FluctuationSummaryMetrics = ({
  widgetSetting,
  isAudienceQuery
}: FluctuationSummaryMetricsProps) => {
  const widgetData = useInsightContentData<{
    status: Status
    data: DashboardWidgetData<AnnotatedMetricResult>[]
    error: FetchErrorResponse | SerializedError | null
  }>(InsightContentType.FLUCTUATION_SUMMARY_METRICS)
  const theme = useSysTheme() as SystemTheme

  return (
    <Container $theme={theme}>
      <RunSearchEffect widgetSetting={widgetSetting} isAudienceQuery={isAudienceQuery}>
        <InsightContentLoadingGuard>
          <StyledSummaryMetricsCompact
            widgetSetting={widgetSetting}
            widgetData={widgetData}
            customTile={Tile}
          />
        </InsightContentLoadingGuard>
      </RunSearchEffect>
    </Container>
  )
}

export default FluctuationSummaryMetrics
